<template>
  <div class="com-footer">
    <div class="top">
      <div class="beset sd-flex-between">
        <div class="item sd-flex-column">
          <el-link :underline="false" href="#/home">首页</el-link>
          <el-link :underline="false" href="#/about">关于我们</el-link>
          <el-link :underline="false" href="#/case">优秀案例</el-link>
        </div>
        <div class="item item sd-flex-column">
          <el-link :underline="false" href="#/product/advantage"
            >产品优势</el-link
          >
          <el-link :underline="false" href="#/product/ecology">生态圈</el-link>
          <el-link :underline="false" href="#/product/total">总体框架</el-link>
          <el-link :underline="false" href="#/product/four">四大平台</el-link>
        </div>
        <div class="item item sd-flex-column">
          <el-link :underline="false" href="#/product/open">开放平台</el-link>
          <el-link :underline="false" href="#/product/technology"
            >技术架构</el-link
          >
          <el-link :underline="false" href="#/product/process"
            >问诊流程</el-link
          >
          <el-link :underline="false" href="#/product/safety">信息安全</el-link>
        </div>
        <div class="item item sd-flex-column">
          <el-link :underline="false" href="#/connect">联系我们</el-link>
          <!--          <div class="text">-->
          <!--            <i class="fa fa-phone"></i>-->
          <!--            <span class="value"></span>-->
          <!--          </div>-->
          <div class="text">
            <i class="fa fa-envelope"></i>
            <span class="value">sanyiyun1@163.com</span>
          </div>
          <div class="img">
            <a
              id="_xinchacharenzheng_cert_vip_ssl"
              style="text-decoration:none;"
              target="_blank"
              href="https://xyt.xinchacha.com/getpcInfo?sn=1538791748900192256&certType=8&url=*.3yicloud.com"
            >
              <img
                src="https://xyt.xinchacha.com/img/icon/icon8.png"
                style="height:50px;width:164px;"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="beset sd-flex-row">
        <div class="item">网站备案号：渝ICP备20001444号</div>
        <div class="item">渝公安网备：500107-50008-20001号</div>
        <div class="item">版权所有：重庆叁伊云科技有限公司 © 2019</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
   * @Class: components
   * @Module: com-footer
   * @Description: 组件 -底部
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/28 22:18" ---*/
export default {
  name: "com-footer"
};
</script>

<style lang="less">
.com-footer {
  width: 100%;

  .top {
    background: #6cc5d9;
    padding: 30px 0;

    .beset {
      width: 1280px;
      margin: 0 auto;

      .item {
        width: 20%;
        align-items: flex-start;

        .el-link {
          padding: 5px;
          font-size: 13px;
          color: #fafafa;

          &:hover {
            color: #e6a23c;
          }
        }

        .text {
          padding: 5px;
          font-size: 13px;
          color: #ffffff;

          .value {
            padding-left: 10px;
          }
        }
      }
    }
  }

  .bottom {
    background: #31708f;

    .beset {
      width: 1280px;
      margin: 0 auto;
      padding: 10px 0;
      justify-content: space-around;

      .item {
        font-size: 13px;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-footer.vue